module.exports = __webpack_public_path__ + "img/sv65.b4645c49.svg";